import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-title" }
const _hoisted_2 = { class: "flex mb-4 justify-end space-x-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-download mr-2" }, null, -1)

import { ref } from 'vue';
import StockDocumentList from "@/components/product/document/StockDocumentList.vue";
import StockAvailableList from "@/components/product/document/StockAvailableList.vue";
import StockNotAvailableList from "@/components/product/document/StockNotAvailableList.vue";
import StockDocumentNotAvailableList from '@/components/product/document/StockDocumentNotAvailableList.vue';
import ApiService from "@/_services/api.service";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';



export default /*#__PURE__*/_defineComponent({
  __name: 'ListDocuments',
  setup(__props) {

const selectedTabIndex = ref(0);
const stockData = ref([]);
const availableData = ref([]);
const notAvailableData = ref([]);
const isLoading = ref<boolean>(true);

function generateFilename() {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    const hour = `${now.getHours()}`.padStart(2, '0');
    const minute = `${now.getMinutes()}`.padStart(2, '0');

    return `export_stocks_${month}_${day}_${year}_${hour}_${minute}.csv`;
}

async function downloadCsv() {
    try {
        const response = await ApiService.get('variant_product_documents/export', { responseType: 'blob' });
        const filename = generateFilename();
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Erreur lors du téléchargement:', error);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("catalogue.documents.title")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "group inline-flex items-center justify-center rounded-lg py-2 px-6 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600",
        to: "/admin/addDocument"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Importer des documents ")
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        onClick: downloadCsv,
        class: "group inline-flex items-center justify-center rounded-lg py-2 px-6 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600"
      }, [
        _hoisted_4,
        _createTextVNode(" Export de stock ")
      ])
    ]),
    _createVNode(_unref(TabView), {
      activeIndex: selectedTabIndex.value,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((selectedTabIndex).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TabPanel), { header: "Disponibles" }, {
          default: _withCtx(() => [
            _createVNode(StockAvailableList, { data: availableData.value }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "Non disponibles" }, {
          default: _withCtx(() => [
            _createVNode(StockNotAvailableList, { data: notAvailableData.value }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "Stock de documents" }, {
          default: _withCtx(() => [
            _createVNode(StockDocumentList, { data: stockData.value }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TabPanel), { header: "Stock vierge" }, {
          default: _withCtx(() => [
            _createVNode(StockDocumentNotAvailableList)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeIndex"])
  ]))
}
}

})